import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Cookies from "universal-cookie";
import DescripcionAgrupada from "./DescripcionAgrupada";
import CrearGestion from "./CrearGestion";
import AccionMejora from "./AccionMejora";
function OmPorUsuario() {
  const cookie = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOmPorEvaluador/" +
        cookie.get("id"),
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Oportunidades de mejora
                </h6>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>

                      <th>Estado Oportunidad</th>
                      <th>Origen</th>
                      <th>Fecha</th>
                      <th>Descripción</th>

                      {cookie.get("tipo_Usuario") == 2 ? (
                        <th>Añadir Gestion</th>
                      ) : (
                        <h></h>
                      )}
                      <th>Consultar Acciones de mejora</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item) => {
                      return (
                        <tr>
                          <td>{item.id}</td>
                          <td>{item.estadoOportunidad}</td>
                          <td>{item.origen}</td>
                          <td>{item.fecha}</td>
                          <td>
                            <DescripcionAgrupada
                              descripcion={item.descripcion}
                              descripcionOmSimilar={item.descripcionOmSimilar}
                            />
                          </td>
                          <td>
                            <CrearGestion idOm={item.id} />
                          </td>

                          <td>
                            <AccionMejora idOm={item.id} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OmPorUsuario;
